"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const SocketCollectionReference_1 = __importDefault(require("./SocketCollectionReference"));
const SocketDocumentSnapshot_1 = __importDefault(require("./SocketDocumentSnapshot"));
class SocketDocumentReference {
    constructor(parent, id) {
        this.parent = parent;
        this.id = id;
    }
    get path() {
        return `${this.parent.path}/${this.id}`;
    }
    get driver() {
        return this.parent.driver;
    }
    collection(id) {
        return new SocketCollectionReference_1.default(this.driver, id, this);
    }
    async get() {
        const data = await this.driver.request('documentGet', this.path);
        return new SocketDocumentSnapshot_1.default(this, data);
    }
    async set(data) {
        await this.driver.request('documentSet', this.path, data);
    }
    async update(data) {
        await this.driver.request('documentUpdate', this.path, data);
    }
    async delete() {
        await this.driver.request('documentDelete', this.path);
    }
    async onSnapshot(onNext) {
        const { subscriberId } = await this.driver.request('documentSubscribe', this.path);
        const event = `snapshot:${subscriberId}`;
        const listener = (snapshot) => {
            onNext(new SocketDocumentSnapshot_1.default(this, snapshot));
        };
        this.driver.socket.on(event, listener);
        return async () => {
            this.driver.socket.off(event, listener);
            this.driver.request('unsubscribe', subscriberId);
        };
    }
}
exports.default = SocketDocumentReference;
//# sourceMappingURL=SocketDocumentReference.js.map